import type { DidomiToken } from '../types/didomi';
import { decodeJWT } from '../utils/DecodeJWT';

interface GetDidomiConsentsArgs {
  token: string;
  onError: (error: unknown) => void;
}

export const getDidomiConsents = (args: GetDidomiConsentsArgs) => {
  const decodedDidomiToken = decodeJWT<DidomiToken>(args);

  const enabledPurposes = decodedDidomiToken?.purposes
    ? decodedDidomiToken?.purposes.enabled
    : [];

  const enabledVendors = decodedDidomiToken?.vendors
    ? decodedDidomiToken?.vendors.enabled
    : [];

  return {
    enabledPurposes,
    enabledVendors,
  };
};
